import React, { useEffect, useCallback, useState, useMemo } from 'react';
import ArrowIcon from '../assets/img/arrow_back.svg';
import CartIcon from '../assets/img/cart.svg';
import {ChakraProvider,theme,Image, Box, Center,Flex,Text,Button  } from '@chakra-ui/react';
import Gallery from "react-photo-gallery";
import SelectedImage from "./SelectedImage";
import { debug, useStoreActions, useStoreState } from 'easy-peasy';
import { convertProxyObjectToObj } from '../apis/constants';
import { uniq, map } from 'lodash-es';
import { differenceBy, findLastIndex, isEmpty } from 'lodash';

const SelectionImage = props => {
    const { saveImagesToCart, checkUser, StartSelectBtn } = props;
    const [ photos, setPhotos] = useState([])
    const [ unpurchasedphotos, setunpurchasedphotos] = useState([])
    const [ allphotos, setAllPhotos] = useState([])
    const [ localCart, setLocalCart] = useState([])
    const [selectAll, setSelectAll] = useState(false);
    const [gridMt, GridMt] = useState('auto');
    const [gridMb, GridMb] = useState('14');
    const [gridZd, GridZd] = useState('908');

    const [ _local, _setLocal] = useState([]);
    
    const eventDetails = useStoreState(state => state.eventDetails);
    const eventCollection = useStoreState(state => state.eventCollection);
    const bholaCart = useStoreState(state => convertProxyObjectToObj(state.bholaCart));
    const handleBholaCart = useStoreActions(action => action.handleBholaCart);
    const tempCart = useStoreState(state => (state.tempCart))
    const handleTempCart = useStoreActions(action => action.handleTempCart);
    const handleSingleLevelTempCart = useStoreActions(action => action.handleSingleLevelTempCart);


  const getUniqList = (target) =>  uniq(map(target, 'image_name'))
  
  const callbackFn = useCallback((flag, id, photo) => {
      if(!flag){
          let getIndex = findLastIndex(localCart, photo)
          if(getIndex !== -1){
            delete localCart[getIndex];
            let filterItemFromCart = localCart.filter( image => image);          
            setLocalCart(filterItemFromCart)
            _setLocal(filterItemFromCart);
          }
      }else{
        // localCart[localCart.length] = photo
        setLocalCart(localCart.push(photo))
        _setLocal(localCart);
      
      }
  },[]);

  useEffect(() => {
    let res = _local.filter(el => el)
    _setLocal(res);
  }, [_local.length])

    var morphKey = photos.map(function(el) {
        var o = Object.assign({}, el);
        o.width = (100 - (30 / 10) * 100) / 100;
        o.height = 1;
        o.src = el.thumb_image
        delete o.isSelected
        delete o.isUnSelected
        return o;
 
      })

      const imageRenderer = useCallback(
        ({ index, left, top, key, photo }) => (
          <SelectedImage
            key={photo.image_name}
            margin={"2px"}
            index={index}
            photo={photo}
            left={left}
            top={top}
            callbackFn={callbackFn}
            selected={false}
          />
        ),
        []
      );


      const submitToTempAndCheckUser = (selectedPhotos) => {
        //handleSingleLevelTempCart(_local)
        checkUser(false,selectedPhotos)
      }

    useEffect(() => {
        if(allphotos.length < props.photos.length){

          console.log('allphotos count, props.photos.legth');
          console.log(allphotos.length, props.photos.length);
          let tempData = convertProxyObjectToObj(tempCart)
          console.log('tempdata');
          console.log(tempData);
          console.log('propsdata');
          console.log(convertProxyObjectToObj(eventCollection));
          const getUniqueImagesList = differenceBy(convertProxyObjectToObj(eventCollection), tempData, 'image_name');
        //  const unique = [...new Set(getUniqueImagesList.map(item => item.image_name))];
        const unique = getUniqueImagesList.filter( (ele, ind) => ind === getUniqueImagesList.findIndex( elem => elem.image_name === ele.image_name && elem.image_name === ele.image_name))
          console.log(unique, 'getUnbiq')
          setAllPhotos(unique);  
         
            const filteredphotos=unique.filter(item=>item.is_purchased!=true);
            console.log('filtereddata');
            console.log(filteredphotos);
            setPhotos(filteredphotos);
            
        }
    }, [])

    useEffect(() => {
      console.log('_local', _local)
    }, [_local])

    return(
        <ChakraProvider theme={theme}>  
        <Flex
          flexDirection="column"
          bg="white"
          position="fixed"
          top="0"
          w="100%"
          zIndex="911"
        >
          <Flex
            alignItems="center"
            justifyContent="space-between"
            boxShadow="0px 10px 40px 0px rgb(0 0 0 / 12%)"
          >
            <Box pt="4" pb="4" pl="4">
              <Image
                src={ArrowIcon}
                alt="Arrow Icon"
                w="4"
                h="4"
                onClick={StartSelectBtn}
              />
            </Box>
            <Box pt="4" pb="4" pl="6">
              <Text
                fontSize={15}
                color="#222222"
                fontWeight={700}
                textAlign={'center'}
              >
                Select photos to Buy
              </Text>
            </Box>
            <Box pt="4" pb="4" pr="4">
              <Center>
                <Flex
                  mt="-5"
                  alignItems="center"
                  justifyContent="center"
                  ml="-3"
                  w="18px"
                  h="18px"
                  bg="#FA2F45"
                  borderRadius="40"
                  position="absolute">
                    
                  <Text color="white" fontSize="11px" pt="1px" fontWeight="700">
                    {_local?.length}
                  </Text>
                </Flex>
                <Image src={CartIcon} alt="Cart Icon" w="6" h="6" />
                <Text
                  fontSize={15}
                  fontWeight={400}
                  color="#000000"
                  pl="2"
                  pt="1"
                >
                  &#8377; {Number(eventDetails.per_photo_price* _local?.length)}
                </Text>
              </Center>
            </Box>
          </Flex>
        </Flex>


            <Box
            p="5px"
            pt="20px"
            bg="#ffffff"
            mb="40"
            zIndex={gridZd}
           height="100vh"
            mt="-27%">
            <Gallery photos={morphKey} renderImage={imageRenderer} />
            </Box>

               <Flex
                flexDirection="column"
                justifyContent="center"
                className="screen-bottom-cntr"
                pt="4"
                pb="4"
                boxShadow="-3px 4px 16px 0px rgb(118 114 114 / 89%)"
                position="fixed"
                bottom="0"
                bg="white"
                zIndex={gridZd}
              > 
                <Text
                  w="100%"
                  color="#FA2F45"
                  pt="0"
                  pb="2"
                  textAlign="center"
                  fontSize="16px"
                  fontWeight="600"
                  borderBottom=".6px solid #e9e9e9"
                  textDecoration="underline"
                  onClick={() => checkUser(true,_local)}
                >
                  Buy all photos for Rs. {Number(eventDetails.all_photos_price)}
                </Text>
                <Flex justifyContent="space-around" w="100%" pt="4">
                  <Button
                    color="#FA2F45"
                    bg="white"
                    h="12"
                    borderRadius="40"
                    border="1px solid #FA2F45"
                    onClick={() => saveImagesToCart(_local)}
                  >
                    Save for later
                  </Button>
                  <Button
                    onClick={e => submitToTempAndCheckUser(_local)}
                    pl="6"
                    pr="6"
                    color="white"
                    bg="#FA2F45"
                    h="12"
                    borderRadius="40"
                  >
                    Buy Photos
                  </Button>
                </Flex>
              </Flex>
            
        </ChakraProvider>
    )
}


export default SelectionImage;